import React from 'react';

export const SquareLogo = ({ className = "w-6 h-6" }) => (
  <img src="/icon-square.png" alt="Square" className={`${className} rounded-lg object-contain`} />
);

export const ShopifyLogo = ({ className = "w-6 h-6" }) => (
  <img src="/icon-shopify.png" alt="Shopify" className={`${className} rounded-lg object-contain`} />
);

export const EbayLogo = ({ className = "w-6 h-6" }) => (
  <img src="/icon-ebay.png" alt="eBay" className={`${className} rounded-lg object-contain`} />
);

export const StripeLogo = ({ className = "w-6 h-6" }) => (
  <img src="/icon-stripe.png" alt="Stripe" className={`${className} rounded-lg object-contain`} />
);
